import {
  Button,
  Dialog,
  DialogTrigger,
  Modal,
  ModalOverlay,
} from "@light-technology/components";
import { Plus, XClose } from "@untitledui/icons";
import { useState } from "react";
import { PARTNER_SUCCESS_EMAIL } from "../utilities/constants";

export const AddPlanButton = () => {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <DialogTrigger
      isOpen={isOpen}
      onOpenChange={() => {
        setIsOpen(!isOpen);
      }}
    >
      <Button
        size="md"
        iconLeading={Plus}
        data-ph-capture-attribute-action="add-plan-clicked"
      >
        Add plan
      </Button>
      <ModalOverlay isDismissable>
        <Modal>
          <Dialog>
            <div className="flex w-[400px] flex-col gap-4xl rounded-2xl bg-primary p-3xl">
              <div className="flex flex-col">
                <div className="flex flex-row items-center justify-between">
                  <div className="text-md font-semibold text-primary">
                    Creating new plans is coming soon
                  </div>
                  <XClose
                    className="cursor-pointer text-quaternary"
                    onClick={() => {
                      setIsOpen(false);
                    }}
                  />
                </div>
                <div className="font-ligh text-sm text-tertiary">
                  In the meantime, please reach out to us at{" "}
                  <a
                    href={`mailto:${PARTNER_SUCCESS_EMAIL}`}
                    target="_blank"
                    className="underline"
                  >
                    {PARTNER_SUCCESS_EMAIL}
                  </a>{" "}
                  to set up another plan.
                </div>
              </div>
              <Button
                onClick={() => {
                  setIsOpen(false);
                }}
              >
                Got it
              </Button>
            </div>
          </Dialog>
        </Modal>
      </ModalOverlay>
    </DialogTrigger>
  );
};
